import { render, staticRenderFns } from "./SpecialDataTable.vue?vue&type=template&id=dbadd61c&scoped=true&"
import script from "./SpecialDataTable.vue?vue&type=script&lang=js&"
export * from "./SpecialDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbadd61c",
  null
  
)

export default component.exports